const UserRole = {
  EMPLOYEE: 'EMPLOYEE',
  MANAGER: 'MANAGER'
}

const RecordStatus = {
  CREATED: 'CREATED', // new record created
  SENT: 'SENT', // user validation, waiting for administrator validation
  REFUSED: 'REFUSED',
  VALIDATED: 'VALIDATED', // administrator validated
  ADD_BABYSITTING_MODE: 'ADD_BABYSITTING_MODE',
  ARCHIVED: 'ARCHIVED'
}

const DeclarationStatus = {
  CREATED: 'CREATED',
  SUBMITTED: 'SUBMITTED',
  SENT: 'SENT'
}

// List only events that should be displayed in history bloc
const HistoryEvents = {
  // CREATED: 'Création du dossier',
  SENT: 'Dépôt du dossier',
  VALIDATED: 'Validation du dossier',
  REFUSED: 'Refus du dépôt de dossier',
  WAITING: 'Mise en attente du dossier',
  ARCHIVED: 'Archivage d\'un dossier',
  UNARCHIVED: 'Réactivation d’un dossier',
  ADD_BABYSITTING_MODE: 'Rajout d\'un mode de garde',
  AUDIT_OK: 'Audit OK',
  AUDIT_KO: 'Audit KO',
  DECLARATION_CREATED: 'Création de déclaration mensuelle',
  DECLARATION_SUBMITTED: 'Dépôt de déclaration mensuelle',
  DECLARATION_CONTROLLED: 'Contrôle de déclaration mensuelle',
  DECLARATION_REJECTED: 'Rejet de déclaration mensuelle',
  DECLARATION_SENT: 'Validation de déclaration mensuelle',
  RESTORE_BASAGE: 'Reprise des données',
  RGPD_OBLIVION: 'Révocation du consentement'
}

const EmployeeHistoryEvents = [
  HistoryEvents.SENT,
  HistoryEvents.ADD_BABYSITTING_MODE,
  HistoryEvents.DECLARATION_CREATED,
  HistoryEvents.DECLARATION_SUBMITTED
]

function cameFromEmployee(historyEventType) {
  const eventType = HistoryEvents[historyEventType]
  return EmployeeHistoryEvents.includes(eventType)
}


export {
  UserRole, RecordStatus, DeclarationStatus, HistoryEvents, cameFromEmployee
}
